/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav P�ibyl (pribyl@cadwork.cz)
 *
 */

import IScene from "./scene_interface";

export default
class Listener {
    private static UID: number = 1;
    private _sceneAPI: IScene;
    private _UID: number;
    private _type: string;
    private _caller: any;
    private _callback: any;

    constructor(aSceneAPI: IScene, aType: string, aCallback: any, aCaller: any) {
        this._sceneAPI = aSceneAPI;
        this._UID = Listener.UID++;

        this._type = aType;
        this._caller = aCaller;
        this._callback = aCallback;
    }

    public getUID() {
        return this._UID;
    }

    public getType() {
        return this._type;
    }

    public getCaller() {
        return this._caller;
    }

    public getCallback() {
        return this._callback;
    }

    public remove() {
        return this._sceneAPI.removeListener(this);
    }
}
